import React, { useContext, useEffect } from 'react'
import './ThankYouNew.css'
import succeessfullAnimationJson from '../../../images/new_ui_imgs/successfully-send.json';
import lottie from 'lottie-web';
import LanguageTranslater from "../../HOC/LanguageTranslater";
import { SpeakerContext } from '../../../context/SpeakerContext';
import { Button } from 'unified-ui-components-library';


function ThankYouNew({ translate }) {

    const { handleAudioIconDisplay } = useContext(SpeakerContext)

    useEffect(() => {
        handleAudioIconDisplay(false)
        const instance = lottie.loadAnimation({
            container: document.querySelector("#thank-you-animation-div"),
            animationData: succeessfullAnimationJson,
            // loop: false
        })
        return () => {
            instance.destroy()
        }

    }, [])

    return (
        <div className='thank-you-cntnr'>
            <div className='thank-page-new-content' >
                <div className='thnk-you-img'>
                    <div id='thank-you-animation-div' ></div>
                </div>
                <div className='thnk-you-head-txt'>
                    <p>
                        {translate("policy_verification_successfully_completed")}
                    </p>
                </div>
                <div className='thnk-you-para-txt'>
                    <p>
                        {translate("thank_You_text")}
                    </p>
                </div>
            </div>
            <div className='thank-you-button'>
                <Button
                    buttonType='secondary'
                    width="264"
                >
                    {translate('Close this page')}
                </Button>
            </div>
        </div>
    )
}

export default LanguageTranslater(ThankYouNew)